namespace $.$$ {
	
	export class $shm_hitalama_app_book extends $.$shm_hitalama_app_book {
		override auto() {
			// The working project/map is not mounted while its guide is shown.
			// Do not start that book's route/full-record/event initialization.
			const app = this.$.$shm_hitalama_app.Root(0)
			if( app.guide_opened() && app.guide_replaces_content() ) return []
			return super.auto()
		}
		override spread_ids_filtered() {
			return super.spread_ids_filtered().filter( id => ![ '', 'lists', 'duckdb_page' ].includes( id ) )
		}
		@ $mol_mem
		override spread( next?: string ) {
			const spread = super.spread( next ) || 'maps'
			// Old bookmarks resolve to the same catalogue, without rewriting stored data.
			return spread === 'components' || spread === 'projects' && this.$.$mol_state_arg.value( 'project' )?.startsWith( 'hyperbase:' )
				? 'applications' : spread
		}

		@ $mol_mem_key
		override Menu_link( spread: string ) {
			const link = super.Menu_link( spread )
			link.event_click = next => this.menu_link_click( spread, next )
			link.current = ()=> this.spread() === spread
			return link
		}

		@ $mol_action
		menu_link_click( spread: string, next?: Event | null ) {
			if( next == null ) return null
			if( this.spread() === spread ) {
				next.preventDefault()
				next.stopPropagation()
				return next
			}
			return next
		}

		projects_map_id() {
			return this.$.$shm_hitalama_domain.instance().Projects_map()?.remote()?.link().str ?? ''
		}

		override arg( spread: string ) {
			const arg = { ...super.arg( spread ), help: spread === 'maps' || spread === 'knowledge' ? 'off' : spread, help_page: null }
			if( spread === 'knowledge' ) return { ...arg, knowledge: null, guide_page: null }
			if( spread !== 'projects' ) return arg
			return {
				... arg,
				project: null,
				project_tab: null,
				project_version: null,
				project_version_output: null,
				goal_run: null,
				session: null,
				projects_map: this.$.$mol_state_arg.value( 'projects_map' ),
			}
		}

		override pages_deep() {
			return this.pages().flatMap( page => page instanceof $mol_book2 ? page.pages_deep() : [ page ] )
		}
		
		@ $mol_mem_key
		maps_list_toggle_visible( spread: string ) {
			return spread === 'maps' ? super.maps_list_toggle_visible( spread ) : []
		}

		@ $mol_mem_key
		projects_list_toggle_visible( spread: string ) {
			return spread === 'projects' ? super.projects_list_toggle_visible( spread ) : []
		}

		profile_id() {
			const profile = this.$.$shm_hitalama_profile.current()
			return profile?.Login()?.val() || profile?.link().toString() || ''
		}
		
	}
	
}
